// extracted by mini-css-extract-plugin
module.exports = {"container":"JiHrm","redDot":"_3meSj","flasher":"_3tGaF","content":"_34We_","title":"_4wmxV","avatar":"_1NEQK","rightPanel":"_3KoUa","badge":"E0cqD","message":"_1sz0M"};